<!-- 文档附件 -->
<template>
  <div class="document-attachment">
    <el-form :model="queryParams" :rules="rules">
      <p class="info-title">规格基础信息</p>

      <div class="business-info-block">
        <el-form-item label="原厂产品资料附件：" label-width="190px">
          <MyFileUpload :upLoadFileList="queryParams.originalAttachment"
          @upFileKey="(e, f) => uploadDocSuccess('originalAttachment', e, f)"/>
        </el-form-item>

        <el-form-item label="中性产品资料附件：" label-width="190px">
          <MyFileUpload :upLoadFileList="queryParams.neutralAttachment" 
          @upFileKey="(e, f) => uploadDocSuccess('neutralAttachment', e, f)"/>
        </el-form-item>

        <el-form-item label="产品视频:" label-width="190px">
          <div class="cover">
            <div class="img_box">
              <uploadVideo
                :videos="videoResults"
                :videosId="videos"
                @uploadOneImg="uploadOneImgvideo"
                @removeImg="removeImgvideo"
              ></uploadVideo>
            </div>
            
            <!-- <div class="img_box" v-else>
              <uploadVideo
                @uploadOneImg="uploadOneImgvideo"
                @removeImg="removeImgvideo"
              ></uploadVideo>
            </div>
            <div v-if="videoResults">缩略图</div>
            <div v-if="videoResults" class="thumbnail">
              <div class="thumbnail_box">
                <img :src="videoResults[0].coverImage" alt="" />
                <div>视频尺寸：442*226 px</div>
                <div>图片大小：4MB</div>
                <div>展示位置：首页</div>
              </div>
              <div class="thumbnail_box">
                <img :src="videoResults[0].coverImage" alt="" />
                <div>视频尺寸：442*226 px</div>
                <div>图片大小：5MB</div>
                <div>展示位置：文章详情页</div>
              </div>
            </div> -->
          </div>
        </el-form-item>
      </div>

      <p class="info-title">原厂产品规格文档</p>

      <div class="business-info-block">
        <div class="attr-info">
          <el-form-item label="产品资料附件：">
            <div class="operate-group">
              <UploadFile :buttonText="'上传附件'" @success="e => uploadFactoryDoc(e, '0')"/>

              <div class="delete-box">
                <el-button plain size="small" icon="el-icon-delete"
                @click="handleDeletes(0)" >批量删除</el-button>
              </div>
            </div>
          </el-form-item>

          <div class="attr-table-box">
            <el-table :data="originalFactoryDocList" style="width: 870px"
            @selection-change="originalFactoryDocChange">
              <el-table-column type="selection" width="105"> </el-table-column>

              <el-table-column label="附件名称" prop="attachmentName" width="500"></el-table-column>

              <el-table-column label="操作" align="center">
                <template slot-scope="{ row }">
                  <button-table content="下载" icon="jr-iconjr-icon-download" @buttonClick="downloadFactoryDoc(row)"/>
                  <button-table content="查看" icon="jr-iconjr-icon-eye" @buttonClick="handleView(row)"/>
                  <button-table content="编辑" icon="jr-iconjr-icon-edit" @buttonClick="handleEdit(row)"/>
                  <button-table content="删除" icon="jr-iconjr-icon-delect" :iconClolor="'#f56c6c'" @buttonClick="handleDelete(row)"/>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <p class="info-title">智参产品规格文档</p>

      <div class="business-info-block">
        <div class="attr-info">
          <el-form-item label="产品资料附件：">
            <div class="operate-group">
              <UploadFile :buttonText="'上传附件'" @success="e => uploadFactoryDoc(e, '1')"/>

              <div class="delete-box">
                <el-button plain size="small" icon="el-icon-delete"
                @click="handleDeletes(1)" >批量删除</el-button>
              </div>
            </div>
          </el-form-item>

          <div class="attr-table-box">
            <el-table :data="procductDocList" style="width: 870px"
            @selection-change="procductDocChange">
              <el-table-column type="selection" width="105"> </el-table-column>

              <el-table-column label="附件名称" prop="attachmentName" width="500"></el-table-column>

              <el-table-column label="操作" align="center">
                <template slot-scope="{ row }">
                  <button-table content="下载" icon="jr-iconjr-icon-download" @buttonClick="downloadFactoryDoc(row)"/>
                  <button-table content="查看" icon="jr-iconjr-icon-eye" @buttonClick="handleView(row)"/>
                  <button-table content="编辑" icon="jr-iconjr-icon-edit" @buttonClick="handleEdit(row)"/>
                  <button-table content="删除" icon="jr-iconjr-icon-delect" :iconClolor="'#f56c6c'" @buttonClick="handleDelete(row)"/>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-form>

    <FileUploadPopup ref="fileUploadPopup" :show="popupShow" @close="popupShow = false" @uploadSuccess="handleUploadSuccess"/>
  </div>
</template>

<script>
// components
import MyFileUpload from "@/components/MyFileUpload/index.vue";
import uploadVideo from "@/components/uploadVideo.vue";
import UploadFile from "@/components/UploadFile.vue";
import ButtonTable from "@/components/ButtonTable.vue";
import FileUploadPopup from "@/components/FileUploadPopup/index.vue"
// api
import { findProductDocument, updateProductDocument } from "@/api/product.js"
// utils
import { downFile } from '@/utils/tool';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    MyFileUpload,
    uploadVideo,
    UploadFile,
    ButtonTable,
    FileUploadPopup
  },
  data() {
    //这里存放数据
    return {
      queryParams: {
        productVideo: "",
        neutralAttachment: [], // 中性产品资料附件
        originalAttachment: [], // 原厂产品资料附件
        productDocList: []
      },
      productAttrList: [{}],
      videoResults: null,
      popupShow: false,
      videos: [],
      rules: {},
      factoryDocChooseList: [],
      productChooseList: [],
      editId: '',
      isInit: false
    };
  },
  computed: {
    originalFactoryDocList() {
      if(Array.isArray(this.queryParams.productDocList)) {
        return this.queryParams.productDocList.filter((item) => {
          return item.specificationType == 0
        })
      } else {
        return []
      }
    },
    procductDocList() {
      if(Array.isArray(this.queryParams.productDocList)) {
        return this.queryParams.productDocList.filter((item) => {
          return item.specificationType == 1
        })
      } else {
        return []
      }
    }
  },
  methods: {
    getInfo(flag = true) {
      if (this.isInit && flag) {
        return;
      }

      findProductDocument({ productCode: this.$route.query.productCode }).then(res => {
        if (res.code == 200 && res.data) {
          for(let key in res.data) {
            this.isInit = true;
            if(['neutralAttachment', 'originalAttachment'].includes(key)) {
              if(typeof res.data[key] === 'string') {
                this.queryParams[key] = [res.data[key]];
              }
            } else if(key === 'video') {
              this.videoResults = res.data[key]
             }else {
              this.queryParams[key] = res.data[key]
            }
          }
        }
      })
    },
    handleView(row) {
      window.open(this.getSeverFileUrl(row.attachmentFile));
    },
    uploadDocSuccess(key, list, file) {
      if(list.length) {
        this.queryParams[key] = [file.name];
      }
    },
    submit(flag = false, deleteFlag = false) {
      const params = {
        ...JSON.parse(JSON.stringify(this.queryParams))
      }

      if(Array.isArray(params.neutralAttachment)) {
        params.neutralAttachment = params.neutralAttachment.join('')
      }

      if(Array.isArray(params.originalAttachment)) {
        params.originalAttachment = params.originalAttachment.join('')
      }

      this.$modal.loading('正在保存数据，请稍候...');
      updateProductDocument(params).then(res => {
        if(res.code === 200) {
          if(deleteFlag) {
            this.$message.success("删除成功");
          } else {
            this.$message.success("编辑成功");
          }

          if(flag) {
            this.getInfo(false)
          }
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$modal.closeLoading();
      });
    },
    //视频上传
    uploadOneImgvideo(val) {
      if(Array.isArray(val)) {
        this.queryParams.productVideo = val.join('');
      }
    },
    removeImgvideo(val) {
      console.log(val);
    },
    uploadFactoryDoc(e, type) {
      this.queryParams.productDocList.push({
        attachmentFile: e.url,
        attachmentIntro: e.type,
        attachmentName: e.name,
        specificationType: type
      })

      this.submit(true)
    },
    originalFactoryDocChange(e) {
      this.factoryDocChooseList = e;
    },
    procductDocChange(e) {
      this.productChooseList = e;
    },
    downloadFactoryDoc(row) {
      downFile(
				{ urlStr: this.getSeverFileUrl(row.attachmentFile) }, // 后台需要的参数
				'/public/downloadUrlFile', // 路径
				row.attachmentIntro, // 下载的文件类型
				row.attachmentName //下载文件名称
			);
    },
    handleEdit(row) {
      this.editId = row.id;
      this.popupShow = true;
    },
    handleUploadSuccess(e) {
      const index = this.queryParams.productDocList.findIndex(item => {
        return item.id === this.editId
      })

      this.popupShow = false;
      if(index === -1) {
        this.$message.error("修改失败");
      } else {
        this.queryParams.productDocList[index].attachmentIntro = e.type;
        this.queryParams.productDocList[index].attachmentName = e.name;
        this.queryParams.productDocList[index].attachmentFile = e.url;
        this.$refs.fileUploadPopup.clear();
        this.submit(true)
      }
    },
    handleDelete(row) {
      const index  = this.queryParams.productDocList.findIndex(item => {
        return item.id === row.id
      })

      this.$confirm("确认删除此条附件吗 ?", "提示")
        .then(async () => {
          if(index === -1) {
            this.$message.error("删除失败");
          } else {
            this.queryParams.productDocList.splice(index, 1)
            this.submit(true, true)
          }
        })
        .catch(() => {});
    },
    handleDeletes(flag) {
      let list = [];
      if(flag === 1) {
        list = this.productChooseList;
      } else {
        list = this.factoryDocChooseList;
      }

      if(!list.length) {
        this.$message.warning("请选择需要批量删除的数据！");
        return;
      }
      
      this.$confirm("确认删除所选附件吗 ?", "提示")
        .then(async () => {
          list.forEach(item => {
            const index = this.queryParams.productDocList.findIndex(chid => {
              return chid.id === item.id
            })

            if(index !== -1) {
              this.queryParams.productDocList.splice(index, 1)
              this.submit(true, true)
            }
          })
        })
    }
  }
};
</script>

<style scoped lang="less">
.document-attachment {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .business-info-block {
    border-bottom: 20px solid #d8efff;

    &:last-child {
      border-bottom: 0;
    }

    .table-box {
      margin-top: 10px;
      padding-left: 190px;
      padding-bottom: 10px;

      .table-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 16px;
        color: #333333;

        &::before {
          content: "";
          display: block;
          margin-right: 4px;
          width: 7px;
          height: 7px;
          background-color: #1e9fff;
          border-radius: 50%;
        }
      }
    }
  }

  .operate-group {
    display: flex;
    align-content: center;
  }

  .delete-box {
    margin-left: 15px;
  }

  .attr-info {
    margin-left: 45px;
  }
}
</style>
